import React from "react";
import { Doughnut } from "react-chartjs-2";
import "bootstrap/dist/css/bootstrap.min.css";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

const ScoreChart = ({ score, maxScore = 100 }) => {
    const percentage = (score / maxScore) * 100;

    const chartData = {
        datasets: [
            {
                data: [score, maxScore - score], // Filled & remaining
                backgroundColor: ["#36a2eb", "#e0e0e0"], // Score color & grey background
                hoverBackgroundColor: ["#2a95d3", "#d6d6d6"],
                borderWidth: 0, // Removes border lines
                cutout: "70%", // Makes the doughnut thinner
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            tooltip: { enabled: false }, // Hides tooltip
        },
    };

    return (
        <div className="position-relative d-flex justify-content-center align-items-center" style={{ width: 200, height: 200 }}>
            <Doughnut data={chartData} options={chartOptions} />
            <div className="position-absolute text-center" style={{ fontSize: "24px", fontWeight: "bold" }}>
                {percentage.toFixed(0)}%
            </div>
        </div>
    );
};

export default ScoreChart;
